export const templateFn = function anonymous(locals, escapeFn, include, rethrow
) {
"use strict";
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc) {
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm);
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<div class=\"nb-menu-body\">\n  <div class=\"nb-messages-list\">\n    <% if (!$ctrl.teams) { %>\n      <svg class=\"nb-spinner\" aria-label=\"<%= t('SPINNER.loading')%>\">\n        <title><% t('SPINNER.loading')%></title>\n        <use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#svg-spinner\"></use>\n      </svg>\n    <% } else if ($ctrl.teams.length <= 0) { %>\n      <div class=\"nb-menu-empty-state\">\n        <h2 class=\"nb-menu-empty-state__main\"><%= t('CHAT.empty_title') %></h2>\n        <p class=\"nb-menu-empty-state__sub\"><%= t('CHAT.empty_description') %></p>\n      </div>\n    <% } else { %>\n      <div role=\"list\" aria-label=\"<%= t('CHAT.chats_list')%>\">\n      <% $ctrl.teams.forEach(function(team) { %>\n          <a\n            role=\"listitem\"\n            href=\"<%= config.urls.apiProxy %>/v3/doorway_redirect?originator_system=<%= team.originator_system === 'Ngin' ? 'Ngin' : 'TeamService' %>&originator_type=<%= team.originator_system === 'Ngin' ? team.originator_type : 'team' %>&originator_id=<%= team.originator_system === 'Ngin' ? team.originator_id : team.id %>&context_tags=chat\"\n            nb-event=\"Chats:Click:ViewChat\"\n            target=\"_top\"\n            class=\"nb-messages-list__item nb-messages-list__item--<%= team.unreadCount < 1 ? 'read' : 'unread' %>\"\n            data-message-id=\"<%= team.id %>\">\n            <span class=\"nb-list-item__avatar\">\n              <%- team.avatar %>\n            </span>\n            <span class=\"nb-message-summary\">\n              <div class=\"nb-message-summary__head\">\n                <span class=\"nb-message-summary__subject\"><%= team.name %></span>\n                <span class=\"nb-message-summary__unread-indicator\"></span>\n                <span class=\"nb-message-summary__date\"><%= team.unreadCount%> unread</span>\n              </div>\n              <div class=\"nb-message-summary__detail\">\n                <% if (team.lastReadMessage && !isNaN(team.lastReadMessage.getTime())) { %>\n                  <%= t('CHAT.last_read', { last_read_date: formatDate(team.lastReadMessage) }) %>\n                <% } %>\n              </div>\n            </span>\n          </a>\n      <% }) %>\n      </div>\n    <% } %>\n  </div>\n</div>\n"
  , __filename = undefined;
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  var __locals = (locals || {}),
$ctrl = __locals.$ctrl,
  config = __locals.config,
  formatDate = __locals.formatDate,
  hasTouch = __locals.hasTouch,
  initializeCSSVars = __locals.initializeCSSVars,
  initialsFromFullName = __locals.initialsFromFullName,
  multiToggleFactory = __locals.multiToggleFactory,
  t = __locals.t,
  htmlWebpackPlugin = __locals.htmlWebpackPlugin;
    ; __append("<div class=\"nb-menu-body\">\n  <div class=\"nb-messages-list\">\n    ")
    ; __line = 3
    ;  if (!$ctrl.teams) { 
    ; __append("\n      <svg class=\"nb-spinner\" aria-label=\"")
    ; __line = 4
    ; __append(escapeFn( t('SPINNER.loading')))
    ; __append("\">\n        <title>")
    ; __line = 5
    ;  t('SPINNER.loading')
    ; __append("</title>\n        <use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#svg-spinner\"></use>\n      </svg>\n    ")
    ; __line = 8
    ;  } else if ($ctrl.teams.length <= 0) { 
    ; __append("\n      <div class=\"nb-menu-empty-state\">\n        <h2 class=\"nb-menu-empty-state__main\">")
    ; __line = 10
    ; __append(escapeFn( t('CHAT.empty_title') ))
    ; __append("</h2>\n        <p class=\"nb-menu-empty-state__sub\">")
    ; __line = 11
    ; __append(escapeFn( t('CHAT.empty_description') ))
    ; __append("</p>\n      </div>\n    ")
    ; __line = 13
    ;  } else { 
    ; __append("\n      <div role=\"list\" aria-label=\"")
    ; __line = 14
    ; __append(escapeFn( t('CHAT.chats_list')))
    ; __append("\">\n      ")
    ; __line = 15
    ;  $ctrl.teams.forEach(function(team) { 
    ; __append("\n          <a\n            role=\"listitem\"\n            href=\"")
    ; __line = 18
    ; __append(escapeFn( config.urls.apiProxy ))
    ; __append("/v3/doorway_redirect?originator_system=")
    ; __append(escapeFn( team.originator_system === 'Ngin' ? 'Ngin' : 'TeamService' ))
    ; __append("&originator_type=")
    ; __append(escapeFn( team.originator_system === 'Ngin' ? team.originator_type : 'team' ))
    ; __append("&originator_id=")
    ; __append(escapeFn( team.originator_system === 'Ngin' ? team.originator_id : team.id ))
    ; __append("&context_tags=chat\"\n            nb-event=\"Chats:Click:ViewChat\"\n            target=\"_top\"\n            class=\"nb-messages-list__item nb-messages-list__item--")
    ; __line = 21
    ; __append(escapeFn( team.unreadCount < 1 ? 'read' : 'unread' ))
    ; __append("\"\n            data-message-id=\"")
    ; __line = 22
    ; __append(escapeFn( team.id ))
    ; __append("\">\n            <span class=\"nb-list-item__avatar\">\n              ")
    ; __line = 24
    ; __append( team.avatar )
    ; __append("\n            </span>\n            <span class=\"nb-message-summary\">\n              <div class=\"nb-message-summary__head\">\n                <span class=\"nb-message-summary__subject\">")
    ; __line = 28
    ; __append(escapeFn( team.name ))
    ; __append("</span>\n                <span class=\"nb-message-summary__unread-indicator\"></span>\n                <span class=\"nb-message-summary__date\">")
    ; __line = 30
    ; __append(escapeFn( team.unreadCount))
    ; __append(" unread</span>\n              </div>\n              <div class=\"nb-message-summary__detail\">\n                ")
    ; __line = 33
    ;  if (team.lastReadMessage && !isNaN(team.lastReadMessage.getTime())) { 
    ; __append("\n                  ")
    ; __line = 34
    ; __append(escapeFn( t('CHAT.last_read', { last_read_date: formatDate(team.lastReadMessage) }) ))
    ; __append("\n                ")
    ; __line = 35
    ;  } 
    ; __append("\n              </div>\n            </span>\n          </a>\n      ")
    ; __line = 39
    ;  }) 
    ; __append("\n      </div>\n    ")
    ; __line = 41
    ;  } 
    ; __append("\n  </div>\n</div>\n")
    ; __line = 44
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

}; export default templateFn